import { useEffect, useState } from "react";
import { Mail, FileDown } from "lucide-react";
import { toast } from "sonner";
import { api, downloadFile, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { LetterEmailSection } from "@/components/LetterEmailSection";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const OPTS = [
  ["clienti", "pdf", "Lettere personalizzate · PDF"], ["clienti", "docx", "Lettere personalizzate · Word"],
  ["modello", "pdf", "Modello generico · PDF"], ["modello", "docx", "Modello generico · Word"],
];

export function AccessLettersButton() {
  const [open, setOpen] = useState(false);
  const [sum, setSum] = useState(null);
  const [busy, setBusy] = useState(null);
  useEffect(() => { if (open) api.get("/letters/access/summary").then((r) => setSum(r.data)).catch(() => {}); }, [open]);

  const get = async (kind, fmt) => {
    setBusy(kind + fmt);
    try {
      await downloadFile(`/letters/access?format=${fmt}&template=${kind === "modello"}`, `Lettera_Accesso_CRM_${kind}.${fmt}`);
      toast.success("Documento generato");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };

  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} data-testid="letters-open-button"><Mail className="h-4 w-4 mr-1" />Lettere di accesso</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-white max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="letters-dialog">
          <DialogHeader>
            <DialogTitle className="font-heading">Lettera di presentazione del CRM</DialogTitle>
            <DialogDescription>Una lettera per ogni anagrafica collegata a un Trust con email: nome, Trust di riferimento ed email da usare per l'accesso.</DialogDescription>
          </DialogHeader>
          {sum && (
            <p className="text-sm text-slate-600" data-testid="letters-summary">
              {sum.total} destinatari · {sum.with_user} con utenza Cliente attiva{sum.total - sum.with_user > 0 ? ` · ${sum.total - sum.with_user} con nota “utenza in attivazione”` : ""}
            </p>
          )}
          <div className="grid gap-2 mt-2">
            {OPTS.map(([k, f, l]) => (
              <Button key={k + f} variant={k === "clienti" && f === "pdf" ? "default" : "outline"} disabled={!!busy || (k === "clienti" && sum?.total === 0)}
                className={k === "clienti" && f === "pdf" ? "bg-[#0A2540] hover:bg-[#031B33] text-white justify-start" : "justify-start"}
                onClick={() => get(k, f)} data-testid={`letters-${k}-${f}`}>
                <FileDown className="h-4 w-4 mr-2" />{busy === k + f ? "Generazione…" : l}
              </Button>
            ))}
          </div>
          <LetterEmailSection />
        </DialogContent>
      </Dialog>
    </>
  );
}
